/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  speedDial: Item<'SpeedDial'>;
  speedDialAction: Item<'SpeedDialAction'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  actionShowMessage2: Item<'ActionShowMessage'>;
} = {
  actionShowMessage2: {
    children: [],
    itemId: 'actionShowMessage2',
    parent: 'triggerOnClick',
    props: {
      message: {
        type: 'text',
        value: 'You clicked Speed Dial Action',
      },
      type: 'success',
    },
    type: 'ActionShowMessage',
  },
  root: {
    children: ['speedDial'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
  speedDial: {
    children: ['speedDialAction'],
    itemId: 'speedDial',
    parent: 'root',
    props: {},
    type: 'SpeedDial',
  },
  speedDialAction: {
    children: ['triggerOnClick'],
    itemId: 'speedDialAction',
    parent: 'speedDial',
    props: {
      icon: {
        iconName: 'plus',
        iconType: 'light',
      },
      name: 'Alpha',
    },
    type: 'SpeedDialAction',
  },
  triggerOnClick: {
    children: ['actionShowMessage2'],
    itemId: 'triggerOnClick',
    parent: 'speedDialAction',
    props: {},
    type: 'TriggerOnClick',
  },
};

export const helpRenders: ComponentSample<'SpeedDialAction'>[] = [
  {
    title: 'Speed Dial Action',
    description: 'Try changing the Speed Dial Action props!',
    page,
    exampleId: 'eg1',
    clearParentChildren: true,
    height: 260,
    visibleProps: ['name', 'icon', 'iconColor'],
    item: {
      children: ['triggerOnClick'],
      itemId: 'speedDialAction',
      parent: 'speedDial',
      props: {
        icon: {
          iconName: 'plus',
          iconType: 'light',
        },
        iconColor: { type: 'text', value: 'primary.main' },
        name: 'Alpha',
      },
      type: 'SpeedDialAction',
    },
  },
];
